



import { defineComponent, onMounted, ref} from 'vue';
import axios from 'axios';
import {message, Modal} from "ant-design-vue";
import { Tool } from '@/util/tool';
import {useRoute} from "vue-router";

export default defineComponent({
  name: 'Doc',
  setup() {
    const route = useRoute();
    const docs = ref();
    const html = ref();
    const defaultSelectedKeys = ref();
    defaultSelectedKeys.value = [];

    //当前选中的文档
    const doc = ref();
    doc.value={};

    /**
     *  一级文档树，children属性就是二级文档
     *  [{
     *      id:""
     *      name:""
     *      children:[{
     *          id:""
     *          name:""
     *          ]}
     *  }]
     **/
    const level1 = ref(); //一级文档树，children属性就是二级文档
    level1.value = [];

    /**
     * 文档内容查询
     * */
    const handleQueryContent = (id:number) => {
      axios.get("/doc/findContent/"+id).then((response) => {
        const data = response.data;
        if(data.success){
          doc.value.viewCount++;
          html.value = data.content;
        }else {
          message.error(data.message);
        }
      });
    };

    /**
     * 文档doc数据查询
     **/
    const handleQuery = () => {
      axios.get("/doc/all/"+route.query.ebookId).then((response) => {
        const data = response.data;
        if(data.success){
          docs.value = data.content;
          level1.value = [];
          level1.value = Tool.array2Tree(docs.value,0);

          if(Tool.isNotEmpty(level1)){
            defaultSelectedKeys.value = [level1.value[0].id];
            handleQueryContent(defaultSelectedKeys.value);
            // 初始显示文档信息
            doc.value = level1.value[0];
          }
        }else {
          message.error(data.message);
        }
      });
    };

    const onSelect = (selectKeys:any,info:any)=>{
      console.log('selected',selectKeys,info);
      if(Tool.isNotEmpty(selectKeys)){
        // 选中某个节点，加载该节点的文档信息
        doc.value = info.selectedNodes[0].props;
        //加载内容
        handleQueryContent(selectKeys[0]);
      }
    };

    /**
     * 点赞
     */
    const vote=()=>{
      axios.get("/doc/vote/"+doc.value.id).then((response) => {
        const data = response.data;
        if(data.success){
          doc.value.voteCount++;
        }else {
          message.error(data.message);
        }
      });
    };

    /**
     * 初始启动方法
     */
    onMounted(() => {
      handleQuery();
    });

    return {
      level1,
      html,
      onSelect,
      defaultSelectedKeys,
      doc,
      vote
    }
  }
});
